import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function RemovePhoneSuccessToast(props: Props) {
  const { id } = props

  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="success"
      body={polyglot.t(
        "toasts.remove_phone_success.body",
      )}
      id={id}
    />
  )
}
